import FilterItemSelector from "./FilterItemSelector.vue";
import MultiModeDatePickerSelector from "@/components/MultiModeDatePickerSelector.vue";
import DropdownBody from "@/components/shared/DropdownBody.vue";
export default {
  name: 'DatePickerFilter',
  components: {
    FilterItemSelector,
    MultiModeDatePickerSelector,
    DropdownBody
  },
  expose: ['toggle', 'close'],
  props: {
    date: {
      type: Object,
      required: true
    },
    pillStyle: {
      type: Object,
      default: () => ({
        backgroundColor: 'var(--market-200)',
        color: 'var(--market-950)'
      })
    },
    noCaret: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleHidden() {
      this.$emit('hidden');
    },
    toggle() {
      if (this.loading) {
        // We put this check here to prevent the dropdown from opening 
        // when the date picker is loading
        return;
      }
      this.handleHidden();
      this.$refs.dropdown.toggle();
    },
    close() {
      this.$refs.dropdown.close();
    }
  }
};